import MediaQuery from 'src/DistributionPackages/Avaloq.NodeTypes/Resources/Private/JavaScript/Modules/MediaQuery'

export default class InDetail {
    constructor(inDetailElement) {
        this.navigationButtons = inDetailElement.querySelectorAll('.js-in-detail__btn')
        this.contentContainer = inDetailElement.querySelectorAll('.js-in-detail__content-container')
        this.variant = inDetailElement.getAttribute('data-variant')
        this.stickyCollection = inDetailElement.querySelector('.js-in-detail__sticky-collection')
        this.scrollCollection = inDetailElement.querySelector('.js-in-detail__scroll-collection')
        this.navigation = inDetailElement.querySelector('.js-in-detail__navigation')

        this.initContentContainer()
        this.initStickyTopMargin()
        this.initNavButtons()
        if (this.variant === 'scroll') {
            this.initContentObserver()
        }
    }

    initContentContainer() {
        this.contentContainer[0].classList.add('in-detail__content-container--start')
    }

    initStickyTopMargin() {
        if (window.innerWidth > 992) {
            this.setStickyTopMargin()
        }

        window.addEventListener('resize', () => {
            if (window.innerWidth > 992) {
                this.setStickyTopMargin()
            } else {
                this.scrollCollection.style.marginTop = null
            }
        })
    }

    setStickyTopMargin() {
        let height = 0
        for (let i = 0; i < this.stickyCollection.childNodes.length; i++) {
            const el = this.stickyCollection.childNodes[i]
            height += this.getTotalHeight(el)
            if (el === this.navigation) {
                break
            }
        }
        this.scrollCollection.style.marginTop = height + 'px'
    }

    getTotalHeight(element) {
        let totalHeight = element.offsetHeight
        const computedStyle = getComputedStyle(element)
        totalHeight += parseInt(computedStyle.marginTop)
        totalHeight += parseInt(computedStyle.marginBottom)
        totalHeight += parseInt(computedStyle.paddingTop)
        totalHeight += parseInt(computedStyle.paddingBottom)
        return totalHeight
    }

    initContentObserver() {
        const options = {
            root: null,
            rootMargin: MediaQuery.UpSd.matches ? '-25% 0px -74% 0px' : '-42% 0px -57% 0px',
            threshold: 0,
        }
        const observer = new IntersectionObserver((entries, observer) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    const targetBtn = document.querySelector(`[target-id="${entry.target.id}"]`)
                    this.navigationButtons.forEach((btn) => {
                        btn.classList.remove('in-detail__btn-active')
                    })
                    targetBtn.classList.add('in-detail__btn-active')
                }
            })
        }, options)
        this.contentContainer.forEach((container) => {
            observer.observe(container)
        })
    }

    initNavButtons() {
        this.navigationButtons.forEach((btn) => {
            const target = document.getElementById(btn.getAttribute('target-id'))
            btn.addEventListener('click', (event) => this.onNavBtnClick(event, target))
        })
    }

    onNavBtnClick(event, target) {
        if (this.variant === 'scroll') {
            if (MediaQuery.UpMd.matches) {
                target.scrollIntoView()
            } else {
                let bodyRect = document.body.getBoundingClientRect(),
                    elemRect = target.getBoundingClientRect(),
                    navHeight = this.navigation.offsetHeight,
                    headerSize = document.querySelector('.header__container').offsetHeight,
                    offset = elemRect.top - bodyRect.top - navHeight - headerSize
                window.scrollTo(0, offset)
            }
        } else {
            this.setContainerActive(target)
            this.navigationButtons.forEach((btn) => {
                btn.classList.remove('in-detail__btn-active')
            })
            event.target.classList.add('in-detail__btn-active')
        }
    }

    setContainerActive(target) {
        this.contentContainer.forEach((container) => {
            container.classList.remove('in-detail__content-container--active')
            container.classList.remove('in-detail__content-container--start')
        })
        target.classList.add('in-detail__content-container--active')
    }
}

if (document.readyState !== 'loading') {
    const inDetailElements = document.querySelectorAll('.js-in-detail')
    inDetailElements.forEach((el) => {
        new InDetail(el)
    })
} else {
    new InDetail()
}
